@if (!isLoading) {
<div class="card">
  <div class="card-header">Content</div>
  <div class="card-body">
    <div class="form-group">
      <label class="control-label">Title Tag</label>
      <input type="text" class="form-control" [formControl]="titleTagControl" [formValidation]="titleTagControl" [readOnly]="isReadOnly" />
    </div>

    <div class="form-group">
      <label class="control-label">Meta Description</label>
      <input type="text" class="form-control" [formControl]="metaDescriptionControl" [formValidation]="metaDescriptionControl" [readOnly]="isReadOnly"/>
    </div>

    <div class="form-group">
      <label class="control-label">Alt Image Tags</label>
      <textarea class="form-control" [formControl]="altImageTagsControl" [formValidation]="altImageTagsControl" [readOnly]="isReadOnly"></textarea>
    </div>

    <div class="form-group">
      <label class="control-label">Additional Keywords</label>
      @if (isReadOnly) {
      <input type="text" class="form-control" [value]="additionalKeywordsControl.value?.join(', ')" readonly />
      } @else {
      <ng-select bindLabel="." bindValue="." [items]="altKeywords" [clearable]="true" [multiple]="true"
        [closeOnSelect]="false" [formControl]="additionalKeywordsControl"
        [formValidation]="additionalKeywordsControl"></ng-select>
      }
    </div>

    <div class="form-group">
      <label class="control-label">Schema Markup</label>
      <textarea class="form-control" [formControl]="schemaMarkupControl" [formValidation]="schemaMarkupControl" [readOnly]="isReadOnly"></textarea>
    </div>

    @if (canAddImplementationInstructions) {
    <div class="form-group">
      <label class="control-label">Implementation Instructions</label>
      <textarea class="form-control" [formControl]="implementationInstructionsControl" [formValidation]="implementationInstructionsControl" [readOnly]="isReadOnly"></textarea>
    </div>
    }

    <div [formValidation]="formGroup">
      <div class="form-group" [formValidation]="bodyCopyControl">
        <label class="control-label">Body Copy</label>
        <div>
          <quill-editor [placeholder]="''" [theme]="'snow'" [formControl]="bodyCopyControl" [readOnly]="isReadOnly"></quill-editor>
        </div>
      </div>

      <div class="form-group" [formValidation]="faqCopyControl">
        <label class="control-label">FAQ Copy</label>
        <div>
          <quill-editor [placeholder]="''" [theme]="'snow'" [formControl]="faqCopyControl" [readOnly]="isReadOnly"></quill-editor>
        </div>
      </div>
    </div>
  </div>
</div>
}